import type { TelemetryInstruction } from '@modules/prism/versions/2025-07-01/utils/telemetry/types.api';

/**
 * Recursively extracts all immediate telemetry instructions from a data structure
 *
 * Searches through the entire object tree to find all arrays keyed as 'telemetry'
 * and filters for instructions with trigger: 'immediate'.
 */
export function extractImmediateTelemetry(data: any): TelemetryInstruction[] {
  const results: TelemetryInstruction[] = [];

  if (!data || typeof data !== 'object') {
    return results;
  }

  if (Array.isArray(data)) {
    for (const item of data) {
      results.push(...extractImmediateTelemetry(item));
    }
    return results;
  }

  for (const [key, value] of Object.entries(data)) {
    if (key === 'telemetry' && Array.isArray(value)) {
      const immediate = (value as TelemetryInstruction[]).filter(
        instruction => instruction.trigger === 'immediate',
      );
      results.push(...immediate);
    } else if (value && typeof value === 'object') {
      results.push(...extractImmediateTelemetry(value));
    }
  }

  return results;
}
